import Config from 'react-native-config';

// AUTH
export const { AUTH_CLIENT_ID } = Config;
export const { AUTH_SECRET } = Config;
export const { AUTH_REDIRECT_URL } = Config;
export const AUTH_SCOPE: string[] = Config && Config.AUTH_SCOPE && Config.AUTH_SCOPE.split(',');
export const { AUTH_SERVER_BASE_URL } = Config;
export const { AUTH_SERVER_SINGLE_LOGOUT_URL } = Config;
export const { AUTH_END_POINT_AUTHORIZATION } = Config;
export const { AUTH_END_POINT_FORGOT_USERNAME } = Config;
export const { AUTH_END_POINT_TOKEN } = Config;
export const { AUTH_END_POINT_REVOCATION } = Config;
export const { AUTH_END_POINT_CHANGE_PASSWORD } = Config;
export const REFRESH_ACCESS_TOKEN_EXPIRATION_MINUTES =
  Config.REFRESH_ACCESS_TOKEN_EXPIRATION_MINUTES || 60;

export const NETWORK_ERROR_RETRY_TIMES = Config.NETWORK_ERROR_RETRY_TIMES || 3;
export const UNAUTHORIZED_HTTP_CODE = Config.UNAUTHORIZED_HTTP_CODE || '401';

export const SERVICE_ERROR_RETRY_TIMES = Config.SERVICE_ERROR_RETRY_TIMES || 3;

// VisitPay
export const {
  VISIT_PAY_AUTH_SERVER_BASE_URL,
  VISIT_PAY_AUTH_END_POINT_AUTHORIZATION,
  VISIT_PAY_AUTH_END_POINT_TOKEN,
  VISIT_PAY_AUTH_CLIENT_ID,
  VISIT_PAY_AUTH_SECRET,
  VISIT_PAY_AUTH_REDIRECT_URL,
  VISIT_PAY_AUTH_SCOPE,
  VISIT_PAY_URL,
  VISIT_PAY_DEFAULT_URL
} = Config;

export const CLINIC_LIST_MAX_NUMBER = Config.CLINIC_LIST_MAX_NUMBER || 200;
export const GOOGLE_API_KEY = Config.GOOGLE_GEOCODE_KEY || '';

export const CompanyName = 'Intermountain Health';

export enum AppName {
  base = 'Intermountain Health',
  secondary = 'Intermountain Health patient portal',
  tertiary = 'online patient portal',
  suffix1 = 'app',
  suffix2 = 'mobile app',
  suffix3 = 'patient account',
  suffix4 = 'patient portal',
  suffix5 = 'patient app'
}

export const getAppName = (name: AppName, prefix = '', suffix = ''): string => {
  let retVal = name as string;
  if (!!prefix) {
    retVal = `${prefix} ${retVal}`;
  }
  if (!!suffix) {
    retVal += ` ${suffix}`;
  }
  return retVal;
};
